import type {WorkspaceState} from './model';
export const FREE_RIGHTS = ['즉시 검사 무제한과 모든 파일 판정','진행 중 지원 2개까지 모든 기능','백업·복원·원본 다시 연결·삭제','점검 카드 공유'] as const;
export const SEASON_PASS_RIGHTS = ['진행 중 지원 3개 이상','이전 지원 복사','모든 지원 달력 일괄 받기'] as const;
export const SEASON_PASS = {price:9900,days:180,autoRenew:false} as const;
/**
 * 결제 provider와 검증된 offer가 없는 현재 production 계약이다.
 *
 * 예정 가격과 의향은 표시하되 실제 결제·잠금은 provider 검증 전까지 꺼 둔다.
 */
export const SAFE_OFF_COMMERCE = {
  providerReady: false,
  verifiedOfferReady: false,
  priceDisplays: 1,
  purchaseCtas: 0,
  purchaseIntentEvents: 1,
  allowFreeContinuation: true,
} as const;

export interface PaidExpansionContext {
  firstValueDelivered: boolean;
  explicitExpansionIntent: boolean;
}

export function resolvePaidExpansion(context: PaidExpansionContext) {
  const eligibleMoment = context.firstValueDelivered && context.explicitExpansionIntent;
  const providerOn = SAFE_OFF_COMMERCE.providerReady && SAFE_OFF_COMMERCE.verifiedOfferReady;
  return {
    eligibleMoment,
    surfaceVisible: eligibleMoment && providerOn,
    priceDisplays: providerOn ? 1 : 0,
    purchaseCtas: providerOn ? 1 : 0,
    allowFreeContinuation: !providerOn && SAFE_OFF_COMMERCE.allowFreeContinuation,
  } as const;
}

export function freeAllowance(state:WorkspaceState) {
 const activePrograms=state.programs.filter(p=>p.mode!=='quick'&&state.preparations[p.id]?.outcome.stage!=='closed').length;
 return {activePrograms,limit:2,overLimit:activePrograms>=2,enforced:Boolean(SAFE_OFF_COMMERCE.providerReady&&SAFE_OFF_COMMERCE.verifiedOfferReady)};
}
